import { toast } from "sonner";
import { useState } from "react";
import { timeZoneSchema } from "@ai-crm/shared";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
export function AccountTimeZone({
  timeZone,
  settingsVersion,
  onSave,
  onRefresh,
}: {
  timeZone: string;
  settingsVersion: number;
  onSave: (input: {
    timeZone: string;
    expectedSettingsVersion: number;
  }) => Promise<unknown>;
  onRefresh: () => Promise<unknown>;
}) {
  const [draft, setDraft] = useState(timeZone),
    [pending, setPending] = useState(false),
    [error, setError] = useState<string | null>(null);
  async function save() {
    if (!timeZoneSchema.safeParse(draft).success) {
      setError("Укажите часовой пояс IANA, например Europe/Moscow");
      return;
    }
    setPending(true);
    setError(null);
    try {
      await onSave({
        timeZone: draft,
        expectedSettingsVersion: settingsVersion,
      });
      await onRefresh();
      toast.success("Часовой пояс сохранён");
    } catch {
      setError(
        "Не удалось сохранить. Обновите состояние аккаунта и повторите; ваш выбор сохранён.",
      );
    } finally {
      setPending(false);
    }
  }
  return (
    <fieldset
      className="space-y-3 rounded-lg border bg-card p-4"
      disabled={pending}
    >
      <legend className="px-1 text-sm font-semibold">
        Часовой пояс аккаунта
      </legend>
      <p className="text-sm text-muted-foreground">
        Используется для календарных дат CRM.
      </p>
      <label className="block space-y-2 text-sm font-medium">
        Часовой пояс IANA
        <Input
          list="account-timezones"
          value={draft}
          onChange={(e) => {
            setDraft(e.target.value);
          }}
        />
      </label>
      <datalist id="account-timezones">
        {[
          "Europe/Moscow",
          "Europe/Kaliningrad",
          "Asia/Yekaterinburg",
          "Asia/Novosibirsk",
          "Asia/Vladivostok",
          "UTC",
        ].map((zone) => (
          <option key={zone} value={zone} />
        ))}
      </datalist>
      <Button type="button" disabled={pending} onClick={() => void save()}>
        {pending ? "Сохранение…" : "Сохранить часовой пояс"}
      </Button>
      {error && (
        <p role="alert">
          {error}{" "}
          <Button
            variant="outline"
            size="sm"
            type="button"
            onClick={() => void onRefresh()}
          >
            Обновить состояние
          </Button>
        </p>
      )}
    </fieldset>
  );
}
